export default "__VITE_ASSET__382004d3__"